(function () {
  'use strict';

  /* Ismaniuju namu skaiciuokle - PREMIUM+ variklis (Kasakai MB, iglusmart.eu)
     Presetai + tikslai + apdaila/spalva + pakopos + pasiulymai + taupymas + PDF/konsultacija. */

  var MAX_OPTIONAL = 4;

  function money(cents) {
    return (cents / 100).toLocaleString('lt-LT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function moneyEur(eur) {
    return Math.round(eur).toLocaleString('lt-LT') + ' €';
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* Solidzios vienspalves line-ikonos (currentColor - seka temos spalva) */
  var ICONS = {
    bulb: '<path d="M9 18h6"/><path d="M10 21h4"/><path d="M8.5 14.6A5 5 0 1 1 15.5 14.6c-.6.6-1 1.4-1 2.3v.1h-4.9v-.1c0-.9-.5-1.7-1.1-2.3Z"/>',
    thermo: '<path d="M14 14.7V6a2 2 0 1 0-4 0v8.7a4 4 0 1 0 4 0Z"/>',
    camera: '<path d="M15 8.5v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z"/><path d="m15 11 6-3v8l-6-3Z"/>',
    key: '<circle cx="8" cy="15" r="4"/><path d="m10.8 12.2 8.2-8.2"/><path d="m16.5 4.5 3 3"/><path d="m14.5 8.5 2 2"/>',
    bolt: '<path d="M13 2 4 13h6l-1 9 9-11h-6l1-9Z"/>',
    drop: '<path d="M12 3.2s6 6.4 6 10.8a6 6 0 0 1-12 0C6 9.6 12 3.2 12 3.2Z"/>',
    sos: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.4"/><path d="m5.6 5.6 3.8 3.8M14.6 14.6l3.8 3.8M14.6 9.4l3.8-3.8M5.6 18.4l3.8-3.8"/>',
    cpu: '<rect x="6.5" y="6.5" width="11" height="11" rx="1.5"/><rect x="10" y="10" width="4" height="4"/><path d="M9 3v2.5M15 3v2.5M9 18.5V21M15 18.5V21M3 9h2.5M3 15h2.5M18.5 9H21M18.5 15H21"/>',
    spark: '<path d="M12 3v3.5M12 17.5V21M3 12h3.5M17.5 12H21M5.8 5.8l2.5 2.5M15.7 15.7l2.5 2.5M18.2 5.8l-2.5 2.5M8.3 15.7l-2.5 2.5"/>',
    sofa: '<path d="M4 11V8.5A2.5 2.5 0 0 1 6.5 6h11A2.5 2.5 0 0 1 20 8.5V11"/><path d="M3.5 11A1.5 1.5 0 0 1 5 12.5V15h14v-2.5A1.5 1.5 0 0 1 20.5 11 1.5 1.5 0 0 1 22 12.5V17a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4.5A1.5 1.5 0 0 1 3.5 11Z"/><path d="M6 18v2.2M18 18v2.2"/>',
    shield: '<path d="M12 3 5 5.6V11c0 4.2 2.9 7.4 7 8.4 4.1-1 7-4.2 7-8.4V5.6L12 3Z"/><path d="m9 11.6 2 2 4-4"/>',
    home: '<path d="M3.5 10.5 12 3.5l8.5 7"/><path d="M5.5 9.2V20h13V9.2"/><path d="M10 20v-5.5h4V20"/>',
    bed: '<path d="M3 18v-2.5A1.5 1.5 0 0 1 4.5 14h15a1.5 1.5 0 0 1 1.5 1.5V18"/><path d="M3 18v2.2M21 18v2.2"/><path d="M3 14V7"/><path d="M6.5 14v-1.8a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 1.5 1.5V14"/>',
    utensils: '<path d="M6 3v5.5a2 2 0 0 0 4 0V3"/><path d="M8 8.5V21"/><path d="M15.5 3c-1.2 0-2 1.9-2 4.5s.8 4.5 2 4.5V21"/>',
    bath: '<path d="M4 12V6.4A2.4 2.4 0 0 1 8.3 5"/><path d="M3 12h18v3a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"/><path d="M6.5 19 5.5 21M17.5 19l1 2"/>',
    corridor: '<path d="M4 4 9.5 6v12L4 20Z"/><path d="M20 4 14.5 6v12l5.5 2Z"/>',
    laptop: '<path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h11A1.5 1.5 0 0 1 19 6.5V15H5Z"/><path d="M3 18h18l-1.2-3H4.2Z"/>',
    star: '<path d="m12 3.5 2.5 5.3 5.5.7-4 3.9 1 5.6-5-2.8-5 2.8 1-5.6-4-3.9 5.5-.7Z"/>',
    door: '<path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17"/><path d="M4 21h16"/><circle cx="14.5" cy="12" r=".8" fill="currentColor" stroke="none"/>'
  };
  function ico(name) {
    var p = ICONS[name];
    if (!p) return '';
    return '<svg class="sc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }
  function keys(str) { return String(str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
  function intersects(a, b) { for (var i = 0; i < a.length; i++) { if (b.indexOf(a[i]) >= 0) return true; } return false; }

  function computeQty(d, ctx) {
    var q = Number(d.baseQty) || 0;
    q += (Number(d.perRoom) || 0) * ctx.rooms;
    var step = Number(d.perAreaStep) || 0;
    if (step > 0 && ctx.area > 0) q += Math.ceil(ctx.area / step) * (Number(d.perAreaQty) || 0);
    q += (Number(d.perFloor) || 0) * ctx.extraFloors;
    q += (Number(d.perBath) || 0) * ctx.baths;
    var min = Number(d.minQty) || 1;
    var max = Number(d.maxQty) || 0;
    if (q < min) q = min;
    if (max > 0 && q > max) q = max;
    return Math.max(1, Math.round(q));
  }

  function initCalc(root) {
    var cfgEl = root.querySelector('[data-calc-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var L = cfg.i18n || {};
    var results = root.querySelector('[data-results]');
    var selected = [];
    var finish = 'standard';
    var colorPref = '';
    var mode = 'greitas';
    var roomCounts = {};

    /* ---------- Kontrolės ---------- */
    // Presetai
    var pEl = root.querySelector('[data-presets]');
    if (pEl) {
      var ph = '';
      (cfg.presets || []).forEach(function (p) {
        ph += '<button type="button" class="smart-calc__preset" data-preset="' + esc(p.key) + '"><span class="sc-pico">' + ico(p.icon) + '</span> ' + esc(p.label) + '</button>';
      });
      pEl.innerHTML = ph;
      pEl.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-preset]') : null;
        if (!b) return;
        var pr = (cfg.presets || []).filter(function (x) { return x.key === b.getAttribute('data-preset'); })[0];
        if (!pr) return;
        selected = pr.goals.slice();
        syncGoals();
        pEl.querySelectorAll('[data-preset]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        render();
      });
    }

    // Tikslai
    var gEl = root.querySelector('[data-goals]');
    var gh = '';
    (cfg.goals || []).forEach(function (g) {
      gh += '<button type="button" class="smart-calc__goal" data-goal="' + esc(g.key) + '" aria-pressed="false">' +
        '<span class="smart-calc__goal-ico">' + ico(g.icon) + '</span>' +
        '<span class="smart-calc__goal-txt"><strong>' + esc(g.label) + '</strong><small>' + esc(g.desc) + '</small></span></button>';
    });
    gEl.innerHTML = gh;
    function syncGoals() {
      gEl.querySelectorAll('[data-goal]').forEach(function (b) {
        b.setAttribute('aria-pressed', selected.indexOf(b.getAttribute('data-goal')) >= 0 ? 'true' : 'false');
      });
    }
    gEl.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-goal]') : null;
      if (!b) return;
      var k = b.getAttribute('data-goal');
      var i = selected.indexOf(k);
      if (i >= 0) selected.splice(i, 1); else selected.push(k);
      if (pEl) pEl.querySelectorAll('[data-preset]').forEach(function (x) { x.classList.remove('is-active'); });
      syncGoals();
      render();
    });

    // Spalvos pref
    var cEl = root.querySelector('[data-color-pref]');
    if (cEl) {
      var ch = '<button type="button" class="smart-calc__swatch smart-calc__swatch--any is-active" data-color=""><span>' + esc(L.anyColor || 'Any') + '</span></button>';
      (cfg.colors || []).forEach(function (c) {
        var cLabel = (cfg.isEn && c.en) ? c.en : c.key;
        ch += '<button type="button" class="smart-calc__swatch" data-color="' + esc(c.key) + '" title="' + esc(cLabel) + '"><i style="background:' + esc(c.hex) + '"></i></button>';
      });
      cEl.innerHTML = ch;
      cEl.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-color]') : null;
        if (!b) return;
        colorPref = b.getAttribute('data-color');
        cEl.querySelectorAll('[data-color]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        render();
      });
    }

    // Apdaila
    root.querySelectorAll('[data-finish-opt]').forEach(function (el) {
      el.addEventListener('change', function () { finish = el.value; render(); });
    });

    // Rezimas: greitas / detalus
    root.querySelectorAll('[data-mode]').forEach(function (el) {
      el.addEventListener('change', function () {
        mode = el.value;
        root.classList.toggle('smart-calc--detalus', mode === 'detalus');
        render();
      });
    });

    // Kambariu paletė + sąrašas
    var palette = root.querySelector('[data-room-palette]');
    var roomListEl = root.querySelector('[data-room-list]');
    if (palette) {
      var rph = '';
      (cfg.rooms || []).forEach(function (r) {
        rph += '<button type="button" class="smart-calc__room-btn" data-room-add="' + esc(r.key) + '"><span class="sc-pico">' + ico(r.icon) + '</span> ' + esc(r.label) + ' <b>+</b></button>';
      });
      palette.innerHTML = rph;
      palette.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-room-add]') : null;
        if (!b) return;
        var k = b.getAttribute('data-room-add');
        roomCounts[k] = (roomCounts[k] || 0) + 1;
        renderRoomList(); render();
      });
    }
    function renderRoomList() {
      if (!roomListEl) return;
      var h = '';
      (cfg.rooms || []).forEach(function (r) {
        var c = roomCounts[r.key] || 0;
        if (!c) return;
        h += '<div class="smart-calc__room-item"><span class="smart-calc__room-name"><span class="sc-pico">' + ico(r.icon) + '</span> ' + esc(r.label) + '</span>' +
          '<div class="smart-calc__stepper"><button type="button" class="smart-calc__step-btn" data-room-dec="' + esc(r.key) + '">−</button>' +
          '<span class="smart-calc__step-qty">' + c + '</span>' +
          '<button type="button" class="smart-calc__step-btn" data-room-inc="' + esc(r.key) + '">+</button></div></div>';
      });
      roomListEl.innerHTML = h;
    }
    if (roomListEl) {
      roomListEl.addEventListener('click', function (e) {
        var inc = e.target.closest ? e.target.closest('[data-room-inc]') : null;
        var dec = e.target.closest ? e.target.closest('[data-room-dec]') : null;
        if (inc) { var k = inc.getAttribute('data-room-inc'); roomCounts[k] = (roomCounts[k] || 0) + 1; renderRoomList(); render(); }
        else if (dec) { var k2 = dec.getAttribute('data-room-dec'); roomCounts[k2] = Math.max(0, (roomCounts[k2] || 0) - 1); renderRoomList(); render(); }
      });
    }

    // Kontekstas
    function ctx() {
      var type = (root.querySelector('[data-type]:checked') || {}).value || 'butas';
      var area = Number((root.querySelector('[data-area]') || {}).value) || 0;
      var rooms = Number((root.querySelector('[data-rooms]') || {}).value) || 0;
      var floors = type === 'namas' ? (Number((root.querySelector('[data-floors]') || {}).value) || 1) : 1;
      var baths = Number((root.querySelector('[data-baths]') || {}).value);
      if (isNaN(baths)) baths = type === 'namas' ? 2 : 1;
      if (rooms <= 0) rooms = area > 0 ? Math.max(1, Math.round(area / 20)) : 1;
      return { type: type, area: area, rooms: rooms, floors: floors, extraFloors: Math.max(0, floors - 1), baths: baths };
    }
    root.querySelectorAll('[data-type]').forEach(function (el) {
      el.addEventListener('change', function () {
        var w = root.querySelector('[data-floors-wrap]');
        if (w) w.hidden = el.value !== 'namas' || !el.checked;
        render();
      });
    });
    ['[data-area]', '[data-rooms]', '[data-floors]', '[data-baths]'].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) el.addEventListener('input', function () { if (selected.length) render(); });
    });

    /* ---------- Produkto/varianto parinkimas ---------- */
    function resolveProduct(d) {
      if (finish === 'premium' && d.premium) return { p: d.premium, isPremium: true };
      return { p: d.std, isPremium: false };
    }
    function pickVariant(p) {
      var vs = p.variants || [];
      if (colorPref && p.hasColor) {
        for (var i = 0; i < vs.length; i++) { if (vs[i].color === colorPref && vs[i].available) return vs[i]; }
      }
      for (var j = 0; j < vs.length; j++) { if (vs[j].available) return vs[j]; }
      return vs[0] || null;
    }
    function availColors(p) {
      var seen = {}, out = [];
      (p.variants || []).forEach(function (v) { if (v.color && v.available && !seen[v.color]) { seen[v.color] = 1; out.push(v.color); } });
      return out;
    }
    function colorHex(name) {
      var c = (cfg.colors || []).filter(function (x) { return x.key === name; })[0];
      return c ? c.hex : '#ccc';
    }

    /* ---------- Atranka ---------- */
    function build() {
      var c = ctx();
      var main = [], opt = [];
      (cfg.devices || []).forEach(function (d) {
        if (d.houseTypes && d.houseTypes !== 'abu' && d.houseTypes !== c.type) return;
        var rp = resolveProduct(d);
        if (!rp.p) return;
        var v = pickVariant(rp.p);
        if (!v || !v.available) return;
        var g = keys(d.goals);
        var triggered = g.indexOf('*') >= 0 || intersects(g, selected);
        if (triggered) {
          main.push({ d: d, qty: computeQty(d, c), tier: d.tier === 'recommended' ? 'recommended' : 'essential', p: rp.p, isPremium: rp.isPremium, v: v });
        } else if (intersects(keys(d.suggestFor), selected)) {
          opt.push({ d: d, qty: Math.max(1, Number(d.minQty) || 1), tier: 'optional', p: rp.p, isPremium: rp.isPremium, v: v });
        }
      });
      opt.sort(function (a, b) { return (a.v.price || 0) - (b.v.price || 0); });
      return { main: main, optional: opt.slice(0, MAX_OPTIONAL), c: c };
    }

    // Kambariu rezimo variklis
    function build2() {
      var byKey = {};
      (cfg.devices || []).forEach(function (d) { if (d.key) byKey[d.key] = d; });
      var totals = {}, totalRooms = 0;
      (cfg.rooms || []).forEach(function (r) {
        var cnt = roomCounts[r.key] || 0;
        if (!cnt) return;
        totalRooms += cnt;
        var prof = r.profile || {};
        Object.keys(prof).forEach(function (k) { totals[k] = (totals[k] || 0) + prof[k] * cnt; });
      });
      if (byKey.gateway) {
        var gwQty = 1 + Math.floor(totalRooms / 8);
        totals.gateway = Math.max(totals.gateway || 0, gwQty);
      }
      if (byKey.valdiklis) totals.valdiklis = Math.max(totals.valdiklis || 0, 1);
      var main = [];
      // gateway pirmas
      var order = Object.keys(totals);
      order.sort(function (a, b) { return (a === 'gateway' ? -1 : 0) - (b === 'gateway' ? -1 : 0); });
      order.forEach(function (k) {
        var d = byKey[k];
        if (!d) return;
        var rp = resolveProduct(d);
        if (!rp.p) return;
        var v = pickVariant(rp.p);
        if (!v || !v.available) return;
        main.push({ d: d, qty: totals[k], tier: (k === 'gateway' || d.tier !== 'recommended') ? 'essential' : 'recommended', p: rp.p, isPremium: rp.isPremium, v: v });
      });
      return { main: main, optional: [], c: { area: 1 } };
    }

    function card(item, editable) {
      var d = item.d, p = item.p, v = item.v;
      var line = (Number(v.price) || 0) * item.qty;
      var img = v.image || p.image;
      var h = '<div class="smart-calc__card" data-card>';
      h += '<div class="smart-calc__card-media">';
      if (img) h += '<a href="' + esc(p.url) + '"><img data-media src="' + esc(img) + '" alt="' + esc(d.label) + '" width="64" height="64" loading="lazy"></a>';
      h += '</div>';
      h += '<div class="smart-calc__card-body">';
      h += '<span class="smart-calc__card-label">' + esc(d.label);
      if (item.isPremium) h += ' <span class="smart-calc__badge">' + esc(L.premiumBadge || 'Premium') + '</span>';
      h += '</span>';
      if (d.note) h += '<span class="smart-calc__card-note">' + esc(d.note) + '</span>';
      var colors = availColors(p);
      if (colors.length > 1) {
        h += '<span class="smart-calc__card-swatches">';
        colors.forEach(function (col) {
          h += '<button type="button" class="smart-calc__mini-swatch' + (col === v.color ? ' is-active' : '') + '" data-set-color="' + esc(col) + '" title="' + esc(col) + '"><i style="background:' + esc(colorHex(col)) + '"></i></button>';
        });
        h += '</span>';
      } else {
        h += '<a class="smart-calc__card-choose" href="' + esc(p.url) + '">' + esc(p.title) + '</a>';
      }
      h += '</div>';
      if (editable) {
        h += '<div class="smart-calc__stepper" data-variant="' + esc(v.id) + '" data-price="' + (Number(v.price) || 0) + '">';
        h += '<button type="button" class="smart-calc__step-btn" data-dec aria-label="-">−</button>';
        h += '<span class="smart-calc__step-qty" data-qty>' + item.qty + '</span>';
        h += '<button type="button" class="smart-calc__step-btn" data-inc aria-label="+">+</button></div>';
        h += '<span class="smart-calc__card-sum" data-line>' + money(line) + '</span>';
      } else {
        h += '<div class="smart-calc__card-opt-add">';
        h += '<span class="smart-calc__card-price">' + money(Number(v.price) || 0) + '</span>';
        h += '<button type="button" class="smart-calc__opt-add button" data-opt-add data-variant="' + esc(v.id) + '">' + esc(L.add || '') + '</button></div>';
      }
      h += '</div>';
      return h;
    }

    var lastData = null;
    function render() {
      var styleStep = root.querySelector('[data-style-step]');
      var data;
      if (mode === 'detalus') {
        var totalRooms = Object.keys(roomCounts).reduce(function (s, k) { return s + (roomCounts[k] || 0); }, 0);
        if (!totalRooms) {
          results.innerHTML = '<p class="smart-calc__placeholder">' + esc(L.roomsEmpty || '') + '</p>';
          if (styleStep) styleStep.hidden = true;
          return;
        }
        data = build2();
      } else {
        if (!selected.length) {
          results.innerHTML = '<p class="smart-calc__placeholder">' + esc(L.empty || '') + '</p>';
          if (styleStep) styleStep.hidden = true;
          return;
        }
        data = build();
      }
      if (styleStep) styleStep.hidden = false;
      lastData = data;
      if (!data.main.length && !data.optional.length) {
        results.innerHTML = '<p class="smart-calc__placeholder">' + esc(L.empty || '') + '</p>';
        return;
      }
      var essential = data.main.filter(function (x) { return x.tier === 'essential'; });
      var recommended = data.main.filter(function (x) { return x.tier === 'recommended'; });
      var totalCount = 0, totalPrice = 0, saving = 0, energyCost = 0;
      data.main.forEach(function (x) {
        totalCount += x.qty; totalPrice += (Number(x.v.price) || 0) * x.qty;
        var sy = Number(x.d.savingYear) || 0;
        if (sy > 0) { saving += sy * x.qty; energyCost += (Number(x.v.price) || 0) * x.qty; }
      });

      var html = '<div class="smart-calc__summary"><div class="smart-calc__summary-txt">' +
        esc(L.summary || '') + ' <strong>' + totalCount + ' ' + esc(L.devicesWord || '') + '</strong> ' +
        esc(L.from || '') + ' <strong>' + money(totalPrice) + '</strong></div>';
      if (saving > 0) {
        var pay = energyCost / 100 / saving;
        var payTxt = '';
        if (pay > 0 && pay < 40) payTxt = ' · ' + esc(L.payback || '') + ' <strong>~' + (pay < 1 ? pay.toFixed(1) : Math.round(pay)) + ' ' + esc(L.years || '') + '</strong>';
        html += '<div class="smart-calc__saving">💶 ' + esc(L.savings || '') + ': <strong>~' + moneyEur(saving) + esc(L.perYear || '') + '</strong>' + payTxt + ' <small>(' + esc(L.savingsNote || '') + ')</small></div>';
      }
      html += '</div>';
      if (!data.c.area) html += '<p class="smart-calc__hint">' + esc(L.needArea || '') + '</p>';

      function group(title, items, cls) {
        if (!items.length) return '';
        var g = '<div class="smart-calc__group smart-calc__group--' + cls + '"><h3 class="smart-calc__group-title">' + esc(title) + '</h3>';
        if (cls === 'essential') g += '<p class="smart-calc__infra">' + esc(L.infra || '') + '</p>';
        items.forEach(function (it) { g += card(it, cls !== 'optional'); });
        return g + '</div>';
      }
      html += group(L.essential || 'Essential', essential, 'essential');
      html += group(L.recommended || 'Recommended', recommended, 'recommended');
      html += group(L.optional || 'Optional', data.optional, 'optional');

      var fin = Number(cfg.financingMonths) || 0;
      html += '<div class="smart-calc__foot"><div class="smart-calc__total"><span>' + esc(L.total || '') + '</span><strong data-total>' + money(totalPrice) + '</strong>';
      if (fin > 0) html += '<span class="smart-calc__fin" data-fin>' + esc(L.financing || '') + ' <strong>' + money(totalPrice / fin) + esc(L.perMonth || '') + '</strong> (' + fin + ' ' + esc(L.months || '') + ')</span>';
      html += '</div>';
      html += '<div class="smart-calc__actions">';
      if (cfg.compareUrl) html += '<button type="button" class="smart-calc__compare-btn" data-compare>' + esc(L.compare || '') + '</button>';
      html += '<button type="button" class="smart-calc__pdf" data-pdf>' + esc(L.getPdf || '') + '</button>';
      html += '<a class="smart-calc__consult" data-consult href="' + esc(cfg.consultUrl || '/pages/contact') + '">' + esc(L.consult || '') + '</a>';
      html += '<button type="button" class="smart-calc__addall button" data-addall>' + esc(L.addAll || '') + '</button>';
      html += '</div></div>';

      results.innerHTML = html;
      wire();
    }

    function recalc() {
      var total = 0;
      results.querySelectorAll('[data-card] [data-price]').forEach(function (st) {
        var price = Number(st.getAttribute('data-price')) || 0;
        var qty = Number((st.querySelector('[data-qty]') || {}).textContent) || 0;
        total += price * qty;
        var line = st.parentNode.querySelector('[data-line]');
        if (line) line.textContent = money(price * qty);
      });
      var t = results.querySelector('[data-total]'); if (t) t.textContent = money(total);
      var fin = Number(cfg.financingMonths) || 0;
      var f = results.querySelector('[data-fin]');
      if (f && fin > 0) f.innerHTML = esc(L.financing || '') + ' <strong>' + money(total / fin) + esc(L.perMonth || '') + '</strong> (' + fin + ' ' + esc(L.months || '') + ')';
    }

    function wire() {
      results.querySelectorAll('[data-inc],[data-dec]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var st = btn.closest('[data-variant]');
          var qEl = st.querySelector('[data-qty]');
          var q = (Number(qEl.textContent) || 1) + (btn.hasAttribute('data-inc') ? 1 : -1);
          if (q < 1) q = 1;
          qEl.textContent = q; recalc();
        });
      });
      // Per-card spalvos perjungimas
      results.querySelectorAll('[data-set-color]').forEach(function (b) {
        b.addEventListener('click', function () {
          var cardEl = b.closest('[data-card]');
          var col = b.getAttribute('data-set-color');
          // rasti varianta pagal preke: naudojam lastData
          var idx = Array.prototype.indexOf.call(results.querySelectorAll('[data-card]'), cardEl);
          var all = [].concat(
            lastData.main.filter(function (x) { return x.tier === 'essential'; }),
            lastData.main.filter(function (x) { return x.tier === 'recommended'; }),
            lastData.optional
          );
          var item = all[idx];
          if (!item) return;
          var nv = (item.p.variants || []).filter(function (v) { return v.color === col && v.available; })[0];
          if (!nv) return;
          item.v = nv;
          var st = cardEl.querySelector('[data-variant]');
          if (st) { st.setAttribute('data-variant', nv.id); st.setAttribute('data-price', Number(nv.price) || 0); }
          var addBtn = cardEl.querySelector('[data-opt-add]');
          if (addBtn) addBtn.setAttribute('data-variant', nv.id);
          var media = cardEl.querySelector('[data-media]');
          if (media && (nv.image || item.p.image)) media.src = nv.image || item.p.image;
          var price = cardEl.querySelector('.smart-calc__card-price');
          if (price) price.textContent = money(Number(nv.price) || 0);
          cardEl.querySelectorAll('[data-set-color]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          recalc();
        });
      });
      var addAll = results.querySelector('[data-addall]'); if (addAll) addAll.addEventListener('click', function () { addSet(addAll); });
      results.querySelectorAll('[data-opt-add]').forEach(function (b) { b.addEventListener('click', function () { addOne(b); }); });
      var pdf = results.querySelector('[data-pdf]'); if (pdf) pdf.addEventListener('click', printOffer);
      var consult = results.querySelector('[data-consult]'); if (consult) consult.addEventListener('click', saveOffer);
      var cmp = results.querySelector('[data-compare]'); if (cmp) cmp.addEventListener('click', compareModels);
    }

    function compareModels() {
      if (!lastData) return;
      var seen = {}, list = [];
      lastData.main.forEach(function (it) {
        var h = it.p.handle;
        if (h && !seen[h] && list.length < 4) { seen[h] = 1; list.push({ h: h, id: it.p.id || null }); }
      });
      if (!list.length) return;
      try { localStorage.setItem('iglu_compare_v1', JSON.stringify(list)); } catch (e) {}
      window.location.href = cfg.compareUrl;
    }

    function collectMain() {
      var out = [];
      results.querySelectorAll('.smart-calc__group--essential [data-variant],.smart-calc__group--recommended [data-variant]').forEach(function (st) {
        var vid = st.getAttribute('data-variant');
        var qty = Number((st.querySelector('[data-qty]') || {}).textContent) || 0;
        if (vid && qty > 0) out.push({ id: Number(vid), quantity: qty });
      });
      return out;
    }

    function addSet(btn) {
      var items = collectMain();
      if (!items.length) return;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); }).then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; });
    }
    function addOne(btn) {
      var vid = btn.getAttribute('data-variant'); if (!vid) return;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
        .then(function (r) { return r.json(); }).then(function () { btn.textContent = L.added || 'Added'; document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
        .catch(function () { btn.disabled = false; });
    }

    function offerLines() {
      var lines = [];
      results.querySelectorAll('.smart-calc__card').forEach(function (cardEl) {
        var label = (cardEl.querySelector('.smart-calc__card-label') || {}).textContent || '';
        var st = cardEl.querySelector('[data-variant]');
        var qEl = cardEl.querySelector('[data-qty]');
        var qty = qEl ? (Number(qEl.textContent) || 1) : 1;
        var price = st ? Number(st.getAttribute('data-price')) || 0 : 0;
        if (st) lines.push({ label: label.trim(), qty: qty, price: price });
      });
      return lines;
    }

    function saveOffer() {
      try {
        var lines = offerLines();
        var txt = lines.map(function (l) { return '- ' + l.label + ' x' + l.qty; }).join('\n');
        sessionStorage.setItem('iglu_calc_offer', (L.offerPrefill || '') + '\n\n' + txt);
      } catch (e) {}
      // nuoroda pati nuves i /pages/contact
    }

    function printOffer() {
      var lines = offerLines();
      var total = 0;
      var rows = lines.map(function (l) { total += l.price * l.qty; return '<tr><td>' + esc(l.label) + '</td><td style="text-align:center">' + l.qty + '</td><td style="text-align:right">' + money(l.price) + '</td><td style="text-align:right">' + money(l.price * l.qty) + '</td></tr>'; }).join('');
      var w = window.open('', '_blank');
      if (!w) return;
      var d = new Date();
      var date = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      w.document.write('<!doctype html><html><head><meta charset="utf-8"><title>' + esc(L.pdfTitle || 'IGLU Smart') + '</title>' +
        '<style>body{font-family:Arial,Helvetica,sans-serif;color:#111;padding:32px;max-width:720px;margin:0 auto}' +
        'h1{font-size:20px;margin:0 0 4px}.d{color:#666;font-size:13px;margin-bottom:24px}' +
        'table{width:100%;border-collapse:collapse;font-size:14px}th,td{padding:8px 6px;border-bottom:1px solid #ddd}' +
        'th{text-align:left;color:#666;font-weight:600}tfoot td{font-weight:700;border-top:2px solid #111;border-bottom:0}' +
        '.n{color:#666;font-size:12px;margin-top:20px}</style></head><body>' +
        '<h1>' + esc(L.pdfHeading || '') + '</h1><div class="d">' + date + ' · iglusmart.eu</div>' +
        '<table><thead><tr><th>' + esc(L.colDevice || '') + '</th><th style="text-align:center">' + esc(L.colQty || '') + '</th><th style="text-align:right">' + esc(L.colUnit || '') + '</th><th style="text-align:right">' + esc(L.colSum || '') + '</th></tr></thead>' +
        '<tbody>' + rows + '</tbody>' +
        '<tfoot><tr><td colspan="3">' + esc(L.pdfTotal || '') + '</td><td style="text-align:right">' + money(total) + '</td></tr></tfoot></table>' +
        '<p class="n">' + esc(L.pdfNote || '') + '</p>' +
        '</body></html>');
      w.document.close();
      w.focus();
      setTimeout(function () { w.print(); }, 300);
    }

    render();
  }

  function init() { document.querySelectorAll('[data-smart-calc]').forEach(initCalc); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
